
import { Component, Prop, Vue } from 'vue-property-decorator';
import { getRoleList, setUserRole } from '@/api/users';
import { UserModule } from '../../../store/modules/user';

@Component({
  name: 'SetRoleDialog',
  components: {

  }
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })setRoleVisible!:Boolean;

  @Prop({
    type: Array,
    default: []
  })setRoleData!:[];

  private loadMore = false;
  private page = 1;

  private formSearch = {
    name: ''
  }

  created() {
    this.getRoleList();
  }

  handleSearch() {
    this.page = 1;
    this.getRoleList();
  }

  handleClear() {
    this.page = 1;
    this.formSearch = {
      name: ''
    };
    this.getRoleList();
  }

  // 角色接口
  getRoleList() {
    const params = {
      name: this.formSearch.name,
      company_id: UserModule.getCompanyId,
      page: this.page
    };
    getRoleList(params)
      .then(res => {
        if (res.data) {
          if (this.page === 1) {
            this.tableData = res.data.list;
          } else {
            this.tableData = this.tableData.concat(res.data.list);
          }
        } else {
          this.tableData = [];
        }
        if ((res as any).data && (res as any).data.page_count > (res as any).data.page_current) {
          this.loadMore = true;
        } else {
          this.loadMore = false;
        }
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err
        });
      });
  }

  setUserRole() {
    var userStr = '';
    for (var user of this.setRoleData) {
      userStr += (user as any).id + ',';
    }
    userStr = userStr.substr(0, userStr.length - 1);
    if (this.roleId.length === 0) {
      this.$notify.error({
        title: '提示',
        message: '请选择角色'
      });
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      company_role_id: this.roleId,
      user_str: userStr,
      vip_level: (UserModule.company as any).vip_level
    };
    setUserRole(params)
      .then(res => {
        this.$notify.success({
          title: '提示',
          offset: window.innerHeight * 0.4,
          customClass: 'notification-center',
          message: '设置成功'
        });
        this.addSuccess();
      })
      .catch(err => {
        this.$notify.error({
          title: '错误',
          message: err.msg
        });
      });
  }

  private roleId = []
  private tableData = []

  moreData() {
    this.page = this.page + 1;
    this.getRoleList();
  }

  close() {
    this.$emit('close', false);
  }

  addSuccess() {
    this.$emit('setRoleSuccess', false);
  }
}
